import script from "./FormRegistroUsuario.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormRegistroUsuario.vue?vue&type=script&setup=true&lang=ts"

import "./FormRegistroUsuario.vue?vue&type=style&index=0&id=fd6af650&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd6af650"]])

export default __exports__